var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxalisBoutonCroixBlanc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 51",
    style: {
      enableBackground: "new 0 0 51 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#914E72;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.6,46.6c2.5-2.6,3-4.5,16.9-18.4C39.4,42.1,39.9,44,42.4,46.6l2.9-2.9c-2.6-2.5-4.5-3-18.4-16.9 C40.8,13,42.7,12.4,45.3,10l-2.9-2.9c-2.5,2.6-3,4.5-16.9,18.4C11.6,11.6,11.1,9.7,8.6,7.1L5.7,10c2.6,2.5,4.5,3,18.4,16.9 C10.2,40.8,8.4,41.3,5.7,43.8L8.6,46.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxalisBoutonCroixBlanc);
export default __webpack_public_path__ + "static/media/OXALIS_bouton_croix_blanc.7baba4bce467bb93b1f3bbabfd12370b.svg";
export { ForwardRef as ReactComponent };